import httpServiceMain from "./httpServiceMain";
import { type SerializeObject, serialize } from "@/utils/serializeUtils";

export const getAllNotifications = async (
	params: SerializeObject
): Promise<any> => {
	const paramsSerialized = await serialize(params);
	return httpServiceMain.get(
		`/public/user/notifications${paramsSerialized}`
	);
};

export const markNotificationAsRead = async (
	notificationId: string
): Promise<any> => {
	return httpServiceMain.get(
		`/public/user/notifications/${notificationId}`
	);
};

export const markAllNotificationsAsRead = async (): Promise<any> => {
	return httpServiceMain.post(
		`/public/user/notifications/mark-all-as-read`
	);
};

export const deleteNotification = async (
	notificationId: string
): Promise<any> => {
	return httpServiceMain.delete(
		`/public/user/notifications/${notificationId}`
	);
};
